import { connect } from 'react-redux';
import { TApplicationState } from '../../types/redux';
import { ISpecificationsDetailed } from '../../types/newbuilding/specificationsDetailed';
import { getDetailedSpecifications } from '../../selectors/newbuilding';
import { SpecificationsDetailed } from '../../components/SpecificationsDetailed';

export function mapStateToProps(state: TApplicationState): ISpecificationsDetailed {
  return getDetailedSpecifications(state);
}

export const SpecificationsDetailedContainer = connect(mapStateToProps)(SpecificationsDetailed);
